var map = {
	"./Badge/index.js": 243,
	"./Course/index.js": 230,
	"./CourseForm/index.js": 236,
	"./LoginPage/index.js": 245,
	"./TagsForm/index.js": 237,
	"./Witness/index.js": 231,
	"./WitnessForm/index.js": 235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;